import { Tooltip } from 'antd';
import img_clear_history from "@/assets/images/ai/hotline/clear_history.png";

import "./index.less";

interface Props {
  onClearHistory: () => void;
}

export default function KnowledgeTool(props: Props) {

  const { onClearHistory } = props;

  return (
    <div className='action_toolbar_wrapper'>
      <Tooltip title="清空记录">
        <div className="action_toolbar_cleanBtn" onClick={onClearHistory}>
          <img src={img_clear_history} alt="" width={16} height={16} />
        </div>
      </Tooltip>
    </div>
  )
}

